// Analytics module — API client.
import { api, backendOrigin } from "@/lib/api";

const qs = (params = {}) => {
  const p = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") p.set(k, v);
  });
  const s = p.toString();
  return s ? `?${s}` : "";
};

export const getOverview = (range) => api.get(`/analytics/overview${qs(range)}`).then(r => r.data);
export const getSales = (range) => api.get(`/analytics/sales${qs(range)}`).then(r => r.data);
export const getProductsAnalytics = (range, limit = 30) => api.get(`/analytics/products${qs({ ...range, limit })}`).then(r => r.data);
export const getDelivery = (range) => api.get(`/analytics/delivery${qs(range)}`).then(r => r.data);
export const getCustomers = (range, limit = 50) => api.get(`/analytics/customers${qs({ ...range, limit })}`).then(r => r.data);
export const getProfit = (range) => api.get(`/analytics/profit${qs(range)}`).then(r => r.data);
export const getMarketing = (range) => api.get(`/analytics/marketing${qs(range)}`).then(r => r.data);
export const getForecasting = () => api.get(`/analytics/forecasting`).then(r => r.data);
export const getAlerts = () => api.get(`/analytics/alerts`).then(r => r.data);
export const getSettings = () => api.get(`/analytics/settings`).then(r => r.data);
export const updateSettings = (body) => api.put(`/analytics/settings`, body).then(r => r.data);
export const listAdSpend = (range) => api.get(`/analytics/ad-spend${qs(range)}`).then(r => r.data);
export const addAdSpend = (body) => api.post(`/analytics/ad-spend`, body).then(r => r.data);
export const deleteAdSpend = (id) => api.delete(`/analytics/ad-spend/${id}`).then(r => r.data);

export const reportDownloadUrl = (report, format, range) => {
  const base = backendOrigin();
  return `${base}/api/analytics/reports/${report}${qs({ ...range, format })}`;
};

export async function downloadReport(report, format, range) {
  const res = await api.get(`/analytics/reports/${report}${qs({ ...range, format })}`, { responseType: "blob" });
  const blob = res.data;
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${report}.${format}`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
